export const SET_BACK_PATHNAME = 'SET_BACK_PATHNAME'
export const SET_CLOSE_PATHNAME = 'SET_CLOSE_PATHNAME'
export const SET_IS_CLOSE_BUTTON_VISIBLE = 'SET_IS_CLOSE_BUTTON_VISIBLE'
export const SET_IS_BACK_BUTTON_VISIBLE = 'SET_IS_BACK_BUTTON_VISIBLE'
